import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import {useSurveyContext} from "../../../context/SurveyContext";
import RadioQuestion from "./RadioQuestion";
import TextQuestion from "./TextQuestion";
import TextAreaQuestion from "./TextAreaQuestion";
import CheckboxQuestion from "./CheckboxQuestion";
import {getAnswerErrorMessage} from "../../../utils/questionnaireUtils";
import DateQuestion from "./DateQuestion";
import SingleCheckbox from "./SingleCheckbox";
import DropdownQuestion from "./DropdownQuestion";

function Question(props) {
    const {setActiveField, survey:{answers, errors}, dispatch} = useSurveyContext();

    useEffect(() => {
        setActiveField(props.question.id, true);

        return function cleanup() {
            setActiveField(props.question.id, false);
        };
    }, [props.question.id, setActiveField]);

    const validate = (question, answer) => {
        const errorMessage = getAnswerErrorMessage(question, answer);

        const type = errorMessage ? "SET_ERROR" : "REMOVE_ERROR";

        dispatch({
            type,
            questionId: question.id,
            errorMessage,
        });
    }

    const isShown = props.question.part === props.activePart;

    const commonProps = {
        question: props.question,
        activePart:props.activePart,
        validate,

    }

    let questionElement = <div>Unknown question type {props.question.type}</div>;
    switch (props.question.type) {
        case "radio":
            questionElement = <RadioQuestion {...commonProps}/>
            break;

        case "text":
            questionElement = <TextQuestion {...commonProps}/>
            break;

        case "textarea":
            questionElement = <TextAreaQuestion {...commonProps}/>
            break;

        case "checkbox":
            questionElement = <CheckboxQuestion {...commonProps}/>
            break;

        case "date":
            questionElement = <DateQuestion {...commonProps} />
            break;

        case "singleCheckbox":
            questionElement = <SingleCheckbox {...commonProps} />
            break;

        case "dropdown":
            questionElement = <DropdownQuestion {...commonProps} />
            break;

        default:
            break;
    }

    const answer = answers[props.question.id] || "";
    const questionContent = (<div className={props.isFirst ? "" : isShown ? "mt-6" : ""}>
        {props.question.sectionHeader &&
        <h1 className={isShown ? "mt-6" : "hidden"}>
            {props.question.sectionHeader}
        </h1>
        }

        {questionElement}

        {errors[props.question.id] && isShown &&
        <div className="mt-2 text-red">
            {errors[props.question.id]}
            {props.question.extraErrorMessage && answer &&
                <div>
                    {props.question.extraErrorMessage}
                </div>
            }
        </div>
        }
    </div>);

    const lastQuestionsDiv = document.getElementById("last-questions-portal");
    if(props.question.moveToEndOfPage && lastQuestionsDiv) {
        return ReactDOM.createPortal(questionContent, lastQuestionsDiv);
    }

    return questionContent;
}

export default Question;